import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import { baseUrls } from './const'
import ApiService from '@/services/ApiService.js'
import store from './store/store'
import { MessageBox } from 'element-ui'
import { app } from '@/main.js'
import { filterFlag } from '@/const'

export default {
  install(Vue) {
    // use a new Vue instance as the interface for Vue components to receive/send SignalR events
    // this way every component can listen to events or send new events using this.$hub
    const hub = new Vue()
    Vue.prototype.$hub = hub

    // Provide methods to connect/disconnect from the SignalR hub
    let connection = null
    let startedPromise = null
    let manuallyClosed = false
    let maxRetryTimes = 5
    let retryTimes = 0

    Vue.prototype.startSignalR = () => {
      connection = new HubConnectionBuilder()
        .withUrl(baseUrls.signalRUrl)
        .configureLogging(LogLevel.Trace)
        .build()

      // Forward hub events through the event, so we can listen for them in the Vue components
      connection.on('patientUpdated', data => {
        broadPatientMessage(data, 'patient-updated')
      })
      connection.on('patientStatusUpdated', data => {
        broadPatientMessage(data, 'patient-status-updated')
      })
      connection.on('patientRemoved', data => {
        broadPatientMessage(data, 'patient-moved')
      })
      connection.on('userLogout', data => {
        hub.$emit('user-logout', JSON.parse(JSON.stringify(data)))
      })

      // You need to call connection.start() to establish the connection but the client wont handle reconnecting for you!
      // Docs recommend listening onclose and handling it there.
      // This is the simplest of the strategies
      function start() {
        if (manuallyClosed) return Promise.resolve()
        retryTimes++
        startedPromise = connection
          .start()
          .then(() => {
            retryTimes = 0
            addToGroup()
          })
          .catch(() => {
            if (retryTimes < maxRetryTimes) {
              return new Promise((resolve, reject) =>
                setTimeout(
                  () =>
                    start()
                      .then(resolve)
                      .catch(reject),
                  5000
                )
              )
            } else {
              let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
              MessageBox.confirm(
                `<div class="warning-content">${app.$i18n.t(
                  'text.failed_to_connecte_smartz_service'
                )}.</div> <img class='warning-icon' src=${warningIconUrl}>`,
                app.$i18n.t('text.warning'),
                {
                  confirmButtonText: app.$i18n.t('text.retry'),
                  confirmButtonClass: 'confirm-btn',
                  type: 'warning',
                  customClass: 'delete-warning-box',
                  showClose: true,
                  closeOnClickModal: false,
                  dangerouslyUseHTMLString: true,
                  showCancelButton: false
                }
              ).then(() => {
                // If the user clicks the retry button, the retry times will be cleared and the connection will be reconnected
                retryTimes = 0
                start()
              })
            }
          })
        return startedPromise
      }

      connection.onclose(() => {
        if (!manuallyClosed) start()
      })

      // Start everything
      manuallyClosed = false
      start()
    }
    Vue.prototype.stopSignalR = () => {
      if (!startedPromise) return

      manuallyClosed = true
      return startedPromise
        .then(() => connection.stop())
        .then(() => {
          startedPromise = null
        })
    }

    function addToGroup() {
      let params = {
        ConnectionId: connection.connectionId,
        UserName: store.getters[`user/selecteOrganisationId`]
      }
      ApiService.AddToGroup(params)
        .then(response => {
          if (response.status < 200 || response.status > 299) {
            showAddGroupErr()
          }
        })
        .catch(() => {
          showAddGroupErr()
        })
    }

    function showAddGroupErr() {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      MessageBox.confirm(
        `<div class="warning-content">${app.$i18n.t(
          'text.add_to_smartz_group_failed'
        )}.</div> <img class='warning-icon' src=${warningIconUrl}>`,
        app.$i18n.t('text.warning'),
        {
          confirmButtonText: app.$i18n.t('text.retry'),
          confirmButtonClass: 'confirm-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          showCancelButton: false
        }
      ).then(() => {
        // If the user clicks the retry button, re-add to the group
        addToGroup()
      })
    }

    // Intercept patients only belonging to this filter
    function broadPatientMessage(patient, event) {
      let filter = store.getters[`filter/calculatedFilter`]
      let flag = filter.flag
      if (flag === filterFlag.all) {
        hub.$emit(event, JSON.parse(JSON.stringify(patient)))
      }
      if (flag === filterFlag.building) {
        if (filter.filterIds.includes(patient.buildingId)) {
          hub.$emit(event, JSON.parse(JSON.stringify(patient)))
        }
      }
      if (flag === filterFlag.floor) {
        if (filter.filterIds.includes(patient.floorId)) {
          hub.$emit(event, JSON.parse(JSON.stringify(patient)))
        }
      }
      if (flag === filterFlag.area) {
        ApiService.GetAreaByIds(filter.filterIds).then(response => {
          if (response.data.success) {
            let rooms = []
            response.data.data.forEach(item => {
              item.WardRoom.map(room => {
                rooms.push(room.RoomId)
              })
            })
            if (rooms.includes(patient.roomId)) {
              hub.$emit(event, JSON.parse(JSON.stringify(patient)))
            }
          }
        })
      }
    }
  }
}
